import script from "./SideMenuButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuButton.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuButton.vue?vue&type=style&index=0&id=ec9b75c2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec9b75c2"]])

export default __exports__